<template>
  <div>
    <bb-toggle-switch
      v-if="isBgMultiCurrencyActive"
      :value="showEuroForBg"
      name="preview-in-eur"
      :on-status-label="translations.previewInEur"
      :off-status-label="translations.previewInEur"
      show-status
      class="m-t-30 f-color-blue"
      @input="updateAmount"
    />
    <bb-slider
      class="m-t-20 f-color-blue"
      v-bind="$attrs"
      :key="showEuroForBg"
      :value="visibleAmount"
      :unit="visibleCurrency"
      :min="visibleMinAmount"
      :max="visibleMaxAmount"
      @input="onInput"
    />
  </div>
</template>
<script>
import { useRootStore } from '../../../../../store/root'
import { mapState, mapActions } from 'pinia'
import getCurrency from '../../../utils/getCurrency'
import { bgnToEur, eurToBgn, CurrencyCode } from '@/plugins/currencyFormatters'
import { useDepositStore } from '@/modules/deposits/store/depositStore'

export default {
  name: 'MultiCurrencySlider',
  props: {
    value: Number,
    min: Number,
    max: Number,
    currency: String
  },
  data () {
    return {
      val: this.value,
      visibleAmount: this.value
    }
  },
  computed: {
    ...mapState(useRootStore, ['isBgMultiCurrencyActive']),
    ...mapState(useDepositStore, ['showEuroForBg']),
    translations () {
      return {
        previewInEur: this.$gettext('Preview in EUR')
      }
    },
    convertVisibleValues () {
      return this.isBgMultiCurrencyActive && this.showEuroForBg && this.currency === CurrencyCode.BGN
    },
    visibleMinAmount () {
      if (this.convertVisibleValues) {
        return bgnToEur(this.min)
      }
      return this.min
    },
    visibleMaxAmount () {
      if (this.convertVisibleValues) {
        return bgnToEur(this.max)
      }
      return this.max
    },
    visibleCurrency () {
      if (this.convertVisibleValues) {
        return getCurrency(CurrencyCode.EUR)
      }
      return getCurrency(this.currency)
    }
  },
  methods: {
    ...mapActions(useDepositStore, ['toggleShowEuroForBg']),
    onInput (value) {
      if (this.convertVisibleValues) {
        this.visibleAmount = value
        this.$emit('input', eurToBgn(value))
      } else {
        this.visibleAmount = value
        this.$emit('input', value)
      }
    },
    updateAmount () {
      this.toggleShowEuroForBg()
      if (this.convertVisibleValues) {
        this.visibleAmount = bgnToEur(this.value)
      } else {
        this.visibleAmount = this.value
      }
    }
  }
}
</script>
